var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          staticClass: "app-main-inner edi-bill-search-selector",
          attrs: {
            visible: _vm.innerVisible,
            title: _vm.$t("CargoMsg.Cargo_contactInformationCopy"),
            width: "1000px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.innerVisible = $event
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "filters" },
            [
              _c(
                "el-form",
                { attrs: { "label-width": "80px", "label-position": "left" } },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 10 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: _vm.$t("Payment.businessNumber") }
                            },
                            [
                              _c("el-input", {
                                attrs: { no: "jobNo" },
                                model: {
                                  value: _vm.elForm.jobNo,
                                  callback: function($$v) {
                                    _vm.$set(_vm.elForm, "jobNo", $$v)
                                  },
                                  expression: "elForm.jobNo"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_ShipperId")
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { no: "shipper" },
                                model: {
                                  value: _vm.elForm.shipper,
                                  callback: function($$v) {
                                    _vm.$set(_vm.elForm, "shipper", $$v)
                                  },
                                  expression: "elForm.shipper"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_ConsigneeId")
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { no: "consignee" },
                                model: {
                                  value: _vm.elForm.consignee,
                                  callback: function($$v) {
                                    _vm.$set(_vm.elForm, "consignee", $$v)
                                  },
                                  expression: "elForm.consignee"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_NotifyId")
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { no: "notify" },
                                model: {
                                  value: _vm.elForm.notify,
                                  callback: function($$v) {
                                    _vm.$set(_vm.elForm, "notify", $$v)
                                  },
                                  expression: "elForm.notify"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm.lob === "AI"
                        ? _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("SeaExport.MasterBillNo")
                                  }
                                },
                                [
                                  _c("el-input", {
                                    attrs: { no: "mbl" },
                                    model: {
                                      value: _vm.elForm.mbl,
                                      callback: function($$v) {
                                        _vm.$set(_vm.elForm, "mbl", $$v)
                                      },
                                      expression: "elForm.mbl"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.lob === "AI"
                        ? _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("SeaExport.LoadingPort")
                                  }
                                },
                                [
                                  _c("cargo-advance-select", {
                                    staticStyle: { flex: "1" },
                                    attrs: {
                                      no: "loadingPortCode",
                                      filterable: "",
                                      "select-type":
                                        _vm.selectTypeNames.basic_data_Airport,
                                      "callback-method-type": "value",
                                      "default-value": _vm.elForm
                                        .loadingPortCode
                                        ? _vm.elForm.loadingPortCode
                                        : "",
                                      "callback-params": {
                                        key: "loadingPortCode"
                                      }
                                    },
                                    on: {
                                      parentCallBack: function(obj) {
                                        _vm.elForm.loadingPortCode = obj.value
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { "label-width": "0" } },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "primary", no: "search" },
                                  on: { click: _vm.search }
                                },
                                [_vm._v(_vm._s(_vm.$t("common.btn.query")))]
                              ),
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "primary", no: "reset" },
                                  on: { click: _vm.reset }
                                },
                                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Empty")))]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "app-main-inner-row row-grid",
              staticStyle: { "min-height": "350px", padding: "0" }
            },
            [
              _c("cargo-ag-grid", {
                staticStyle: { width: "100%" },
                attrs: {
                  "grid-options": _vm.gridOptions,
                  "grid-params": _vm.gridParams,
                  "column-defs": _vm.columnDefs,
                  "row-data": _vm.rowData
                },
                on: {
                  "update:gridParams": function($event) {
                    _vm.gridParams = $event
                  },
                  "update:grid-params": function($event) {
                    _vm.gridParams = $event
                  },
                  gridReady: function(params) {
                    return (_vm.gridApi = params.api)
                  }
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", no: "confirm" },
                  on: { click: _vm.confirm }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
              ),
              _c(
                "el-button",
                { attrs: { no: "cancel" }, on: { click: _vm.cancel } },
                [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }